type RenameProperty<
  T extends Record<string, unknown>,
  OldKey extends keyof T,
  NewKey extends string
> = Pick<T, Exclude<keyof T, OldKey>> & { [P in NewKey]: T[OldKey] };

export function renameIt<
  T extends Record<string, unknown>,
  OldKey extends keyof T,
  NewKey extends string
>(obj: T, oldKey: OldKey, newKey: NewKey): RenameProperty<T, OldKey, NewKey> {
  const newObject = { ...obj };
  const value = newObject[oldKey];

  delete newObject[oldKey];
  const newProperty = { [newKey]: value } as { [P in NewKey]: T[OldKey] };

  return Object.assign(newObject, newProperty);
}
